<template>
    <div class="fr-aggregates col pb-3 pb-xl-0">
        <div
            v-tooltip="fraction.tooltip"
            class="card"
            :class="{ inactive: !fraction.active }"
        >
            <div class="card-body justify-content-between gap-1-5 px-3 py-4">
                <fraction-label
                    :fraction="fraction"
                    :disabled="!fraction.active"
                    :active-color="fraction.color"
                />

                <div class="d-flex">
                    <img :src="require(`@/assets/img/drs/${fraction.type}.svg`)" />
                    <div class="align-content-center">
                        <span v-text="fraction.description" />
                        <span v-if="fraction.type != 'mix'" v-text="` (${fraction.details})`" />
                    </div>
                </div>

                <div class="fr-handling-fee text-sm">
                    <span v-text="'Stawki za obsługę frakcji'" class="font-weight-medium" />
                    <div class="fr-handling-fee-row">
                        <span v-text="'Zbiórka manualna'" />
                        <span
                            v-text="defaultHandlingFee"
                            class="font-weight-bold"
                        />
                    </div>
                    <div class="fr-handling-fee-row">
                        <span v-text="'Zbiórka automatyczna'" />
                        <span
                            v-text="defaultHandlingFeeRvm"
                            class="font-weight-bold"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        fraction: {
            type: Object,
            required: true
        }
    },

    computed: {
        defaultHandlingFee() {
            return this.$options.filters.currency(this.fraction.defaultHandlingFee / 100, '', 3)
        },

        defaultHandlingFeeRvm() {
            return this.$options.filters.currency(this.fraction.defaultHandlingFeeRvm / 100, '', 3)
        }
    }
}
</script>

<style lang="scss">
@import '@/styles/_custom.scss';

.fr-aggregates {
    .card {
        --color: var(--color-primary);
        border: 1px solid var(--color);
        color: var(--color);
        &.inactive {
            --color: var(--color-gray-500);
            img {
                filter: grayscale(100%);
            }
        }
    }
    .fr-name {
       font-weight: bold !important;
    }

    .fr-handling-fee {
        display: grid;
        border-top: 1px solid var(--color-gray-200);
        padding-top: 1rem;
        gap: 0.5rem;

        .fr-handling-fee-row {
            display: flex;
            justify-content: space-between;
        }
    }
}
</style>
